import { useState, useCallback, useRef } from "react";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { GetHistoricoByIdSolicitacao } from "@services/SolicitacaoHistorico/Index";

export const useFetchSolicitacaoHistoricoByNumber = () => {
  const [solicitacaoHistoricoLoading, setLoading] = useState(false);
  const [solicitacaoHistoricoOptions, setOptions] = useState([]);
  const [totalItens, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const abortControllerRef = useRef(null); // Para cancelar fetch anteriores

  const fetchSolicitacaoHistorico = useCallback(async (idSolicitacao, page = 1, perPage = 10) => {
    if (!idSolicitacao) {
      setOptions([]);
      setTotal(0);
      return;
    }

    setLoading(true);

    try {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort(); // cancela chamada anterior
      }

      abortControllerRef.current = new AbortController();
      const response = await GetHistoricoByIdSolicitacao(page, perPage, idSolicitacao);

      if (!response) throw new Error("Sem resposta da API");

      const { items, totalItems, pageNumber, pageSize } = response;

      const options = items.map((item) => ({
        id: item.id,
        data: item.data,
        nomeColaborador: item.nomeColaborador,
        perfilColaborador: item.perfilColaborador,
        acaoRealizada: item.acaoRealizada,
        observacoes: item.observacoes,
      }));

      setOptions(options);
      setTotal(totalItems);
      setCurrentPage(pageNumber);
      setRowsPerPage(pageSize);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error("Erro ao buscar histórico:", error);
        SweetAlert.error("Erro ao buscar histórico da solicitação", String(error));
        setOptions([]);
        setTotal(0);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    fetchSolicitacaoHistorico,
    solicitacaoHistoricoOptions,
    setSolicitacaoHistoricoOptions: setOptions,
    solicitacaoHistoricoLoading,
    totalItens,
    currentPage,
    rowsPerPage,
    setCurrentPage,
    setRowsPerPage,
  };
};
